import { createGlobalStyle } from 'styled-components'
import { normalize } from 'polished'

export const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    font-family: 'PingFang SC', 'Hiragino Sans GB', 'Heiti SC', 'Microsoft YaHei', 'WenQuanYi Micro Hei', serif;
  }

  input:focus-visible,
  textarea:focus-visible {
    outline: none;
  }

  body {
    -webkit-tap-highlight-color: rgb(0 0 0 / 0%);
  }

  a {
    text-decoration: none;
  }

  p,
  h3 {
    padding: 0;
    margin: 0;
  }

  input:focus,
  textarea:focus {
    -webkit-tap-highlight-color: rgb(0 0 0 / 0%);
    -webkit-user-modify: read-write-plaintext-only;
    outline: 0;
  }

  input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }

  ${normalize()}
`
